@if (!hide) {
  <div class="app-submenu" >
    @for (app of selectableApps$ | async; track app) {
      @if (!app.internal) {
        <div class="app" (click)="appChange(app)">
          <mat-icon [svgIcon]="app.icon"></mat-icon>
          <div>
            <span id="submenu-option-{{getAppName(app).replace(' ', '-')}}" class="app-name">{{getAppName(app)}}</span>
            @if (app.isExternal) {
              <mat-icon [svgIcon]="icons.ARROW_RIGHT_CORNER" class="app-external-icon"></mat-icon>
            }
          </div>
        </div>
      }
    }
  </div>
}

